import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const ServicesOutlineIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="ServicesOutlineIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/services/outline">
            <path
                fill="none"
                d="M12 2.75L20.25 7.25V16.75L12 21.25L3.75 16.75V7.25L12 2.75ZM3.75 7.25L12 11.75L20.25 7.25M12 11.75V21.25M7.875 5L16.125 9.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
            </path>
        </g>
    </SvgIcon>
)
